import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SavedView } from '../../../../core/interfaces/view.model';

@Component({
  selector: 'app-delete-saved-view-dialog',
  standalone: true,
  imports: [],
  templateUrl: './delete-saved-view-dialog.component.html',
  styleUrl: './delete-saved-view-dialog.component.css'
})
export class DeleteSavedViewDialogComponent {
  @Input() id!: string;

  constructor(
    public activeModal: NgbActiveModal,
  ) {

  }

  closeModal() {
    this.activeModal.dismiss();
  }

  confirmDelete() {
    this.removeFromLocalStorage(this.id);
    this.activeModal.close('deleted');
  }

  private removeFromLocalStorage(id: string) {
    let saved = JSON.parse(localStorage.getItem('savedViews') || '[]');
    saved = saved.filter((x: SavedView) => x.id !== id);
    localStorage.setItem('savedViews', JSON.stringify(saved));
  }

}
